import { createFileRoute } from "@tanstack/react-router";
import { SurveyInbox } from "../components/inbox/SurveyInbox";

export const Route = createFileRoute("/_auth/inbox")({
  staticData: { titleKey: "nav.inbox", breadcrumbKey: "breadcrumb.operate", breadcrumbN: 7 },
  component: SurveyInbox,
});
